export default "__VITE_ASSET__BGISg8S2__"